function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { makeStyles } from '@material-ui/core/styles';
import colors from "../../foundations/colors.module.scss";
import shadows from "../../foundations/shadows.module.scss";
import typography from "../../foundations/typography.module.scss";
import { baseMenuPaperStyles, baseMenuItemStyles } from "../Menu/Menu.styles";
export const useDropdownMenuStyles = makeStyles({
  menu: function menu() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _objectSpread(_objectSpread(_objectSpread({}, baseMenuPaperStyles), {}, {
      // DropdownMenu-specific overrides
      fontFamily: typography.fontFamilyLight,
      fontSize: typography.fontSizeP1,
      background: colors.dark50,
      // Override baseMenuPaperStyles boxShadow with DropdownMenu-specific shadow
      boxShadow: shadows.sh60,
      color: colors.dark700
    }, props), {}, {
      // Apply base menu item styles to all menu items in this menu
      '& .MuiMenuItem-root': baseMenuItemStyles
    });
  },
  promotionalAction: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 20px',
    marginBottom: '-8px',
    background: colors.dark70,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      background: colors.dark100
    }
  }
});